module.exports = require('./block')

module.exports.BlockHeader = require('./blockheader')
module.exports.MerkleBlock = require('./merkleblock')
